/**
 * 异常待处理订单详情
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React,{Fragment} from 'react';
import { Empty, Popover, Spin,Button,message} from "antd";
import Lang from "@components/Lang/Lang";
import ExceptionPendingOrderAction from '../ExceptionPendingOrder.action';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import {isEmpty,isEmptyObject } from '@utils/utils';
import PageCommon from  "@components/PageCommon/PageCommon";
import "./index.less";
import dayjs from "dayjs";
import { numberWithCommas, toFixedWithCommas} from "@utils/number-util";
import Feedback from "./Feedback";

class ExceptionPendingOrderDetail extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            item:{},
            sonItem:{},
            //是否全部都是不需要处理的异常(用于判断按钮显示是'我知道了'还是'保存')
            noCanSave:true,
        }
    }
    /**
     * 列表
     * */
    getSon(poList=[],bigPo={}){
        let children = [];
        poList.forEach((son,index)=>{
            const list = son.itemList||[];
            children.push(<div className={'son-order-item'} key={index}>
                <div className={'padding-box'}>
                    <div className={'info-box'}>
                        <div className={"font_14 title-black font-weight-700"}>{Lang({id: 'ZiDingDan', default: '子订单'})}<span>{son.poCode}</span>
                            {/*【{son.statusName}】*/}
                            【{__getServerDictItem('sale_po_ddp_status_buyer.'+son.statusBuyer)||'-'}】
                        </div>
                        <div className={"font_12 row-grey"}>
                            {Lang({id: 'YuanShiYuJiDaoGangShiJian', default: '原预计到达时间'})}：
                            <span>{son.arrivalPortDate?dayjs(son.arrivalPortDate).format('YYYY-MM-DD'):'-'}</span>
                           {Lang({id: 'XiangShu', default: '箱数'})}：<span className="txt">{son.deliveryQuantity||'-'}</span>
                            {Lang({id: 'KuanShu', default: '款数'})}：<span className="txt">{son.itemCount||'-'}</span>
                            {Lang({id: 'TiJi', default: '体积'})}： <span className="txt">{toFixedWithCommas(son.volume,3)||'-'} m³</span>
                        </div>
                    </div>
                </div>
                <div className="table-content">
                    <table width={'100%'}>
                        <tbody>
                        <tr className={'column-th'}>
                            <td>{Lang({id: 'ShangPinXinXi', default: '商品信息'})}</td>
                            <td className={'widthPrice'}>{Lang({id: 'DanJia', default: '单价'})}</td>
                            <td className={'widthNum'}>{Lang({id: 'XiangShu', default: '箱数'})}</td>
                            <td className={'widthTotal'}>{Lang({id: 'JinE', default: '金额'})}</td>
                        </tr>
                            {this.getItemList(son.itemList,bigPo)}
                        </tbody>
                    </table>
                </div>
            </div>)
        })
        return children
    }
    getItemList(list=[],bigPo){
        let children = [];
        list.forEach((item,index)=>{
            children.push(<tr key={index}>
                <td colSpan={4} >
                    <div className={'column-tr'}>
                        <div className={'pro-pic'}>
                            <Popover placement="right" trigger="click" arrow={true} content={
                                <img src={item.skuFileUrl+'@!200'} style={{width:'200px',height:'200px'}} alt=""/>
                            }>
                                <img src={item.skuFileUrl+'@!100'} className="img" alt=""/>
                            </Popover>
                        </div>
                        <div className={'info'}>
                            <table className={'pro-info'}>
                                <tbody>
                                <tr>
                                    <td>
                                            <p className="name">{item.skuName}</p>
                                            <p className="brand">{item.brandName&&item.brandName+' | '}{item.skuNo}{item.skuHsNo?`(${item.skuHsNo})`:''}</p>
                                    </td>
                                    <td className={'widthPrice'}><b>{bigPo.currencySymbol} {numberWithCommas(toFixedWithCommas(item.price,2))}</b></td>
                                    <td className={'widthNum'}><b>x {item.quantity}</b></td>
                                    <td className={'widthTotal'}><b>{bigPo.currencySymbol} {numberWithCommas(toFixedWithCommas(item.priceTotal,2))}</b></td>
                                </tr>
                                </tbody>
                            </table>
                            {this.getSalePoItemAbnormals(item.salePoItemAbnormals,item)}
                        </div>
                    </div>
                </td>
            </tr>)
        })
        return children;
    }
    getSalePoItemAbnormals=(list=[],item)=>{
        let children = []
        list.forEach((abnormalItem, index)=> {
               children.push(<div key={index} className={`abnormal-tr${item.operationType==="1"?' successTr':''} ${item.operationType==="0"?' cancelTr':''}`}>
                   {/**工厂反馈*/}
                   {(abnormalItem.abnormalType == 10)?
                       <div className="feedbackAbnormal-wrap">
                           <Feedback abnormalItem={abnormalItem}></Feedback>
                       </div>
                       :null
                   }

                       {/**通知型且已取消的异常 无12：无证书 已不作异常 */}
                       {(abnormalItem.abnormalType ==8 ||abnormalItem.abnormalType == 9||abnormalItem.abnormalType == 11)?
                           <div className="abnormal-option-wrap">
                               <ul className="cancel-list color-danger">
                                   <li className="li-4 text-right" style={{width:'20%'}}>{Lang({id:'DingGouLiang',default:'订购量'})}</li>
                                   <li className="li-4 text-right" style={{width:'20%'}}>{Lang({id:'QuXiaoXiangShu',default:'取消箱数'})}</li>
                                   <li className="li-4 text-right" style={{width:'20%'}}>{Lang({id:'QuXiaoShiJian',default:'取消时间'})}</li>
                                   <li className="li-4 text-right" style={{width:'40%'}}>{Lang({id:'QuXiaoYuanYin',default:'取消原因'})}</li>
                               </ul>
                               <ul className="cancel-list margin-top-5">
                                   <li className="li-4 text-right" style={{width:'20%'}}>{item.quantity}</li>
                                   <li className="li-4 text-right" style={{width:'20%'}}>{abnormalItem.abnormalValue}</li>
                                   <li className="li-4 text-right" style={{width:'20%'}}>{abnormalItem.cancelTime?dayjs(abnormalItem.cancelTime).format("YYYY-MM-DD HH:mm:ss"):''}</li>
                                   <li className="li-4 text-right" style={{width:'40%'}}>{abnormalItem.poCancelReasonName}</li>
                               </ul>
                           </div>
                           :null
                       }
                       {/**通知型且未取消的异常*/}
                       {(abnormalItem.abnormalType ==6 ||abnormalItem.abnormalType == 7)?
                           <div
                               className="noticeNoCancelAbnormal abnormal-notify-wrap text-right">{
                               abnormalItem.abnormalType ==7?Lang({id:'TingChanXiaJia',default:'停产下架'}):Lang({id:'YinWuLiaoCaiGouYiChangQuX',default:'因物料采购异常取消'})
                           }</div>
                           :null
                       }
                       {(abnormalItem.abnormalType == '1' ||abnormalItem.abnormalType == '2'||abnormalItem.abnormalType == '3')?
                           <div className="abnormal-option-wrap text-right">
                               <ul className="normal-abnormal clearfix">
                                   {
                                       (abnormalItem.price)?
                                           <li>
                                               <div className="text-right">{Lang({id:'YuanJiaGe',default:'原价格'})}：{numberWithCommas(toFixedWithCommas(item.priceOld,2))}</div>
                                               <div className="new-accept-value">
                                                   <span className="iconfont icon-zhengque"></span>
                                                   <span className="txt">{Lang({id:'XinJiaGe',default:'新价格'})}：{numberWithCommas(toFixedWithCommas(abnormalItem.price,2))}</span>
                                               </div>
                                           </li>
                                           :null
                                   }
                                   {
                                       (abnormalItem.moq)?
                                           <li>
                                               <div className="old-accept-value">{Lang({id:'YuanMOQ',default:'原MOQ'})}：{item.skuPurchaseMoqOld}
                                               </div>
                                               <div className="new-accept-value">
                                                   <span className="iconfont icon-zhengque"></span>
                                                   <span className="txt">{Lang({id:'XinMOQ',default:'新MOQ'})}：{item.skuPurchaseMoq}</span>
                                               </div>
                                           </li>
                                           :null
                                   }
                                   {
                                       (abnormalItem.deliveryDay)?
                                           <li>
                                               <div className="old-accept-value">
                                                   {Lang({id:'YuanShiYuJiDaoGangShiJian',default:'原预计到达时间'})}： {item.arrivalTimeOld?dayjs(Number(item.arrivalTimeOld)).format('YYYY-MM-DD'):''}
                                               </div>
                                               <div className="new-accept-value">
                                                   <span className="ri-checkbox-circle-fill icon-zhengque"></span>
                                                   <span className="txt">{Lang({id:'XinYuJiDaoGangShiJian',default:'新预计到达时间'})}：
                                                       {abnormalItem.deliveryDay?dayjs(Number(abnormalItem.deliveryDay)).format('YYYY-MM-DD'):''}</span>
                                               </div>
                                               <div>
                                                   {(item.operationType == "1"||item.operationType === "0")?
                                                       <Button className="abnormal-cancel-btn"
                                                               onClick={()=>this.rockBackItemClick(item)}>
                                                           {__getServerLanguage('CheXiao')}
                                                       </Button>
                                                       :
                                                       null
                                                   }
                                                   {isEmpty(item.operationType)?<>
                                                       <Button className={"btnPink"}
                                                               onClick={()=>this.acceptItemClick("0",item)}>{Lang({id:"QuXiaoCaiGou",default:"取消采购"})}
                                                       </Button>
                                                       <Button type={"primary"} className={"ml_12 btnPinkPrimary"}
                                                               onClick={()=>this.acceptItemClick("1",item)}>{Lang({id:"JieShouBianDong",default:"接受变动"})}
                                                       </Button>
                                                       </>:null}
                                               </div>
                                           </li>
                                           :null
                                   }
                               </ul>
                           </div>
                           :null
                       }
               </div>)
        })
        return children;
    }
    acceptItemClick(operationType,item){
        item.operationType = operationType;
         this.setState({
             sonItem: this.state.sonItem
         })
    }
    /**
     * 撤销
     * @param item
     */
    rockBackItemClick(item){
        item.operationType = null;
        this.setState({
            sonItem:this.state.sonItem
        });
    }
    /**
     * 查看详情
     * */
    getDetail(containerId){
        this.loading(true);
        const data = {
            containerId:containerId
        }
        ExceptionPendingOrderAction.getDetail(data).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err))
    }
    handleRes(res){
        this.loading(false);
        const {success,valid,model} = res;
        let abnormalPoList = model.abnormalPoList||[];
        let list = [];
        for(let i=0;i<abnormalPoList.length;i++){
            let itemList = abnormalPoList[i].itemList;
            for(let j=0;j<itemList.length;j++){
                let abnormalList = itemList[j].salePoItemAbnormals;
                for(let k=0;k<abnormalList.length;k++){
                    const sAbnormalType =abnormalList[k].abnormalType; //异常类型
                    //如果有非通知型异常，按钮显示提交
                    if(!(abnormalList[k].isNotify||sAbnormalType ==6 ||sAbnormalType == 7)){
                      this.setState({
                          noCanSave:false
                      })
                    }
                    //如果是通知型异常，直接接受了 现在直接接受不显示绿
                    if(sAbnormalType ==8 ||sAbnormalType == 9||sAbnormalType == 11||sAbnormalType == 12){
                        abnormalPoList[i].itemList[j].operationType = '2'; //2即不显示操作成功色但保存时赋值为1
                    }
                    // 后端理解的非通知型异常，实际看起来交互和通知型异常一致
                    if(sAbnormalType ==6 ||sAbnormalType == 7){
                        abnormalPoList[i].itemList[j].operationType = '1';
                    }
                }
            }
            list.push(abnormalPoList[i]);
        };
        if(success&&valid){
            this.setState({
                item:model||{},
                sonItem: list,
            })
        }
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    getCerId(str){
        if(str.length>0) return str.substr(1,str.length);
        return '';
    }
    // 全部接受
    onClickBatch(sonItem=[]){
        let newList = [...sonItem];
        for (let po of newList) {
            for (let item of po.itemList) {
                item.operationType = "1";
            }
        }
        this.setState({
            sonItem: newList,
        });
    }
    onClickBatchSubmit(noCanSave){//noCanSave =true 是 已通知客户
        let poList = [];
        const {sonItem,containerId } = this.state;
        for (let po of sonItem) {
            let data = {
                poId: po.poId,
                abnormalOperations:[]
            }
            for (let item of po.itemList) {
                let opera = {};
                //明细ID
                opera.poItemId = item.id;
                //0：删除（取消采购）；1：接受（确认采购）；2：按MOQ采购；3：只采购可用量；
                opera.operationType = item.operationType=='2'?'1':item.operationType;
                //如果有异常没处理
                if(isEmpty(opera.operationType)){
                    message.info(Lang({id: 'HaiYouYiChangWeiChuLi', default: '还有异常未处理'}))
                    return false;
                }
                data.abnormalOperations.push(opera);
            }
            poList.push(data);
        }
        let postData = {
            containerId: containerId,
            poList:poList
        }
        this.loading(true);
        ExceptionPendingOrderAction.handleAbnormal(postData).then(res=>this.handleResAb(res.data)).catch(err=>this.handleResAb(err))
    }
    handleResAb(res){
        this.loading(false);
        if(res.success&&res.valid){
        const  { item } = this.state;
        // noCertificateSplit == 1 中国直发订单
            this.props.history.push(item.noCertificateSplit == 1 ?`/order/directSale`:`/order/sale`);
        }
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    componentDidMount() {
        const { search } = this.props.location;
        const containerId = this.getCerId(search);
        this.setState({
            containerId:containerId
        })
        this.getDetail(containerId);
    }
    render(){
        const { loading,item,sonItem,noCanSave} = this.state;
        const currPageName = Lang({id: "YiChangDaiChuLiDingDan",default: "异常待处理订单"});
        return ( <Spin spinning={loading}>
            <PageCommon onRef={this.onRefPageCommon}
                        btnList={noCanSave?[{
                            btn: Lang({id:"YiTongZhiKeHu",default:"已通知客户"}),
                            icon:"ri-check-line mr_4 color_F1554C1",
                            btnClick:()=>this.onClickBatchSubmit(noCanSave)
                            }
                        ]:[
                            {
                                btn: Lang({id:"QuanBuJieShouBianDong",default:"全部接受变动要求"}),
                                icon:"ri-upload-cloud-line mr_4 color-yellow",
                                btnClick:()=>this.onClickBatch(sonItem)
                            },
                            {
                                btn: Lang({id:"TiJiaoChuLi",default:"提交处理"}),
                                icon:"ri-check-line mr_4 color_F1554C1",
                                btnClick:()=>this.onClickBatchSubmit(noCanSave)
                            },
                        ]}>
            <CommonBreadcrumb list={[
                { name:currPageName,link:'/order/exceptionPendingOrder'},{name:item.originalPoCode||''}]}></CommonBreadcrumb>
            <div className="exceptionPendingOrderDetail">
                {(item&&item.originalPoCode)?<Fragment>
                    <div className={'padding-box'}>
                        <div className={'top'}>
                            <div className={"font_15"}>
                                <span className={'title-black font-weight-700'}>{Lang({id: 'DingDan', default: '订单'})}<span className={'font_13'}>{item.originalPoCode}</span></span>
                                <span className="font_13 span-count"
                                      dangerouslySetInnerHTML={{ __html: __getServerLanguage('GongNDanDanYouYiChangDaiChuLi',`<span>${item.totalPoNum}</span>`,`<span class="color-danger"> ${item.abnormalPoNum}</span>`) }}></span>
                            </div>
                            <div className={"font_13 title-grey bitPoOrder"}>{Lang({id: 'XiaDanRen', default: '下单人'})}
                                <span>{item.buyerName}</span>
                                <span>{item.buyerEmail}</span>{item.mobile&&<Fragment><span>+{item.telCode} {item.mobile}</span></Fragment>}</div>
                            </div>
                    </div>
                    {/*子订单信息*/}
                    {this.getSon(sonItem,item)}
                </Fragment>:(<Empty description={Lang({id: "WeiZhaoDaoFuHeTiaoJianDeJiLu",default: "未找到符合条件的记录"})} />)}
            </div>
            </PageCommon>
        </Spin> )
    }
}
export default ExceptionPendingOrderDetail;
